export default {
  drawer: true,
  authToken: null,
  activeSite: null,
  activeUser: null,
  admin: false,
  superAdmin: false,
  sites: [],
  permissions: [],
  toast: {
    active: false,
    text: '',
    status: '',
  },
  groupReportSites: [],
};
